import axios from 'axios';
import {
  APP_SETTING_LOAD_PERMISSIONS_BEGIN,
  APP_SETTING_LOAD_PERMISSIONS_SUCCESS,
  APP_SETTING_LOAD_PERMISSIONS_FAILURE,
  APP_SETTING_LOAD_PERMISSIONS_DISMISS_ERROR,
} from './constants';
import { builderSurfaceJsonContentHeader } from '../../../common/utils/restApiHeaderUtils';

export function loadPermissions(args = {}) {
  return (dispatch) => {
    dispatch({
      type: APP_SETTING_LOAD_PERMISSIONS_BEGIN,
    });
    const { projectId, version } = args;
    const header = builderSurfaceJsonContentHeader(projectId);
    const promise = new Promise((resolve, reject) => {
      const doRequest = axios.get(
        `${process.env.REACT_APP_BUILDER_ENGINE}v${version}/items/permission/`,
        header,
      );
      doRequest.then(
        (res) => {
          const { code, data } = res;
          if (code === 404) {
            dispatch({
              type: APP_SETTING_LOAD_PERMISSIONS_FAILURE,
              data: { error: data },
            });
            reject(data);
          }
          dispatch({
            type: APP_SETTING_LOAD_PERMISSIONS_SUCCESS,
            data: data,
          });
          resolve(data);
        },
        (err) => {
          dispatch({
            type: APP_SETTING_LOAD_PERMISSIONS_FAILURE,
            data: { error: err },
          });
          reject(err);
        },
      );
    });

    return promise;
  };
}

export function dismissLoadPermissionsError() {
  return {
    type: APP_SETTING_LOAD_PERMISSIONS_DISMISS_ERROR,
  };
}

export function reducer(state, action) {
  switch (action.type) {
    case APP_SETTING_LOAD_PERMISSIONS_BEGIN:
      return {
        ...state,
        loadPermissionsPending: true,
        loadPermissionsError: null,
      };

    case APP_SETTING_LOAD_PERMISSIONS_SUCCESS:
      return {
        ...state,
        loadPermissionsPending: false,
        loadPermissionsError: null,
        allPermissions: action.data.content || [],
      };

    case APP_SETTING_LOAD_PERMISSIONS_FAILURE:
      return {
        ...state,
        loadPermissionsPending: false,
        loadPermissionsError: action.data.error,
      };

    case APP_SETTING_LOAD_PERMISSIONS_DISMISS_ERROR:
      return {
        ...state,
        loadPermissionsError: null,
      };

    default:
      return state;
  }
}
